<template>
  <div class="iv-activity iv-p-t-24 iv-p-b-40">
    <div class="iv-main-width">
      <Tab v-model="tabName" :navList="navList" @on-click="tabClick"></Tab>
      <List 
        v-if="list.length > 0"
        type="questionnaire" 
        :showPage="true" 
        :map="map" 
        :total="total" 
        :list="list" 
        class="iv-m-t-24"
        @on-page-size-change="changePageSize"
        @on-detail="detailPage"
        @on-change="changePage">
      </List>
      <NoData v-if="list.length <= 0"></NoData>
    </div>
  </div>
</template>

<script>
import Tab from '@/components/tab'
import NoData from '@/components/no-data'
import List from '@/components/declare-list'

export default {
  data () {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      dictMap: {},
      state: '',
      pageSize: 5,
      params: {},
      tabName: '0'
    }
  },
  async created () {
    this.map = {
      title: 'questionnaireName'
    }
    this.initTabs()
    this.currentPage = Number(this.$route.query.currentPage) || 1
    this.tabName = this.$route.query.tabName
    if (this.tabName) {
      this.tabClick(this.tabName)
    } else {
      this.getActivityList()
    }
  },
  methods: {
    //获取问卷列表
    getActivityList () {
      this.judgeParamsName()
      this.$ajax({
        url: 'api-uum/questionnaire/portalQuestionnaireList',
        method: 'get',
        data: {
          currentPage: this.currentPage, 
          pageSize: this.pageSize,
          ...this.params
        }
      }).then((data) => {
        this.list = data.data.data.map(item => ({
          ...item
          // ,
          // reportStateMap: this.dictMap['BOE45'], //报名状态
          // updateStateMap: this.dictMap['BOE25'], //记录修改状态
          // listStateMap: this.dictMap['BOE44'] //是否采纳
        }))
        this.total = data.data.count
      })
    },
    //因为需要传三个状态 所以需要根据码表值进行判断
    judgeParamsName () {
      if (this.state == '0') {
        this.params = {}
      } else if (this.state == '11') {
        this.params = {
          searchQuestionnaireState: 1
        }
      } else if (this.state == '22') {
        this.params = {
          searchQuestionnaireState: 2
        }
      } else if (this.state == '33') {
        this.params = {
          searchQuestionnaireState: 3
        }
      } else if (this.state == '1') {
        this.params = {
          searchSubmitState: 1
        }
      } else if (this.state == '2') {
        this.params = {
          searchSubmitState: 2
        }
      }
    },
    changePage (page) {
      this.currentPage = page
      this.getActivityList()
    },
    changePageSize (page) {
      this.pageSize = page
      this.getActivityList()
    },
    detailPage (item) {
      this.$router.push({
        name: 'questionnaireDetail',
        query: {
          id: this.$encode(item.questionnaireID),
          state: this.$encode(item.submitState),
          currentPage: this.currentPage,
          tabName: this.tabName
        }
      })
    },
    tabClick (name) {
      this.state = name
      this.tabName = name
      this.getActivityList()
    },
    initTabs () {
      this.navList = [{
        label: '全部',
        name: '0'
      }, {
        label: '未开始',
        name: '11'
      }, {
        label: '进行中',
        name: '22'
      }, {
        label: '已结束',
        name: '33'
      }, {
        label: '已完成',
        name: '2'
      }, {
        label: '未参与',
        name: '1'
      }]
    }
  },
  components: {
    Tab,
    List,
    NoData
  }
}
</script>

<style lang="scss" scoped>
.iv-activity {
  min-height: 100%;
  background-color: #fff;
}
</style>
